<template>
  <section class="full">
    <Scrollama
      :offset="0.9"
      :debug="false"
    >
      <div slot="graphic" class="graphic">
        <div id="tag-viz" class="d3-viz tag-viz">
          <span class="controllabel">Number of Tags</span>
          <vue-slider
            v-if="showSlider"
            @change="sliderDebounced"
            v-bind="sliderOptions"
            v-model="tagNum"
            :style="{ width: sliderWidth + 'px' }"
          />
          <div v-if="!dataLoaded" class="preloader">
            <img
              class="wait"
              src="/assets/images/ajax-loader.gif"
              alt="... won't be long ..."
            >
            <p>... won't be THAT long ...</p>
          </div>
          <div id="tagCount" class="tagCount">
            <span id="tagCountText" />
          </div>
          <div id="tooltip" class="tooltip">
            <div class="pointer" id="pointer">
              <p class="text">
                <span id="tagName" />
              </p>
              <p @click.stop="showImages($event)" class="view" id="view-btn">
                <span id="amount" /> photos
              </p>
            </div>
            <div @click.stop="removeToolTip" class="close icofont-close" />
          </div>
        </div>
      </div>

      <div class="step photo-gallery" data-step="photo-gallery">
        <div v-if="imagesShown">
          <div @click="hideImages()" class="closeImages">
            <span class="icofont-close btn-close" />
            <span>
              Top {{ imageGalleryMax }} photos tagged with
              <em>{{ selectedTagName }}</em>
            </span>
          </div>
          <div class="row">
            <div v-for="(imageRow, i) in imageRows" :key="i" class="column">
              <div
                v-for="image in imageRow"
                :key="image.id"
                class="imgContainer"
                :style="'background-color:' + image.color"
              >
                <a :href="getCredits(image,'tag').url" target="_blank">
                  <img
                    src="/assets/images/transparent.png"
                    class="lzy_img"
                    :data-src="getImageURL(image.id)"
                    :alt="image.tag"
                    :style="'background-color:' + image.color"
                  >
                  <span class="credit">
                    Photo by {{ getCredits(image, "tag").username }}
                    on
                    <a
                      :href="$root.unsplashURL + utmStr"
                      target="_blank"
                    >Unsplash</a>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Scrollama>
  </section>
</template>

<script>
import TagViz from "../js/tag/d3-tag"
import TagView from "../views/Tag.vue"
import "intersection-observer"
import Scrollama from "vue-scrollama"
import VueSlider from "vue-slider-component"
import { constants } from "crypto"
import { prototype } from "events"
import { lazyLoadImages } from "../mixins/lazyLoad.js"
import { photogallery } from "../mixins/photo-gallery.js"
import _ from "lodash"

export default {
    name: "TagViz",
    mixins: [lazyLoadImages, photogallery],
    components: {
        VueSlider,
        Scrollama
    },
    data() {
        return {
            tagNum: 10,
            sliderOptions: {
                min: 2,
                max: 20
            },
            showSlider: 0,
            sliderWidth: 0,
            tagviz: null,
            dataLoaded: false,
            data: null,
            imageArray: [],
            imageGalleryMax: 100,
            selectedTagName: "",
            imagesShown: false,
            currentStepProgress: null,
            utmStr:""
        }
    },
    mounted() {

        if (localStorage.d3_tag) {
            const locStorage = JSON.parse(localStorage.d3_tag)
            this.tagNum = locStorage.settings.topTags
        }

        // Create new Class of viz
        const tagviz = new TagViz("tag-viz", this.tagNum)
        this.tagviz = tagviz

        this.data = tagviz.loadData("unsplash-d3-camera").then(json => {
            this.dataLoaded = true
            this.data = json
            this.tagviz.init()
            this.tagviz.drawBase()
            this.tagviz.drawContent(json)

            // slider
            this.showSlider = 1
            this.sliderWidth = tagviz.dimensions.arcRadius * 2
        })

        window.addEventListener("resize", () => {
            this.resizeDebounced()
        })
    },
    methods: {
        resizeDebounced: _.debounce(function draw() {
            this.tagviz.resize()
        }, 250),
        sliderDebounced: _.debounce(function slide() {
            this.redrawViz()
        }, 500),
        
        removeToolTip() {
            this.tagviz.hideToolTip()
            this.hideImages()
        },
        showImages(event) {
            const index = event.target.dataset.index
            const tag = this.tagviz.selectedTags[index]

            // find all images with this tag
            this.imageArray = this.tagviz.tagArray.filter(obj => {
                return obj.tag === tag
            }).slice(0, this.imageGalleryMax-1)

           
            this.imagesShown = true
            this.selectedTagName = this.tagviz.selectedTagName
            this.lazyLoadImages()

            const gallery = document.querySelector(".photo-gallery")
            gallery.classList.add("active")
        },
        hideImages() {
            this.imagesShown = false
            this.selectedTagName = ""

            const gallery = document.querySelector(".photo-gallery")
            gallery.classList.remove("active")
        },
        getImageURL(id) {
            const photoNode = this.tagviz.tagArray.find(obj => {
                return obj.id === id
            })

            // Target width : 800px
            const targetWidth = 800
            const targetheight = (targetWidth / photoNode.width) * photoNode.height
            const imageURL = `${photoNode.urls.raw}&w=${targetWidth}&h=${targetheight}&fit=crop&q=85&fm=jpg&crop=entropy&cs=srgb`

            return imageURL
        },        
        redrawViz() {
            this.tagviz.updateTags(this.tagNum)
        }

    }
}
</script>

<style src="vue-scrollama/dist/vue-scrollama.css"></style>

<style lang="scss">
$themeColor: #1fdbc8;
$bgColor:rgba(0,0,0,0.4);
@import "vue-slider-component/lib/theme/antd.scss";

.vue-slider {
  max-width: 600px;
}
</style>


<style scoped lang="stylus">
@import './css/photogallery.styl';
@import './css/tooltip.styl';

.d3-viz {
  text-align: center;
  margin: 0 auto;
  width: 100%;
  height: 100%;
}

.d3-viz >>> svg {
  &.wrapper {
    margin-top: 20px;
  }

  & .label {
    font-size: 14px;
    color: #777;
  }

  & .overlay, .handle {
    pointer-events: none; // prevent creation of new brushes and resizing
  }
}

.full {
  text-align: center;
  margin: 0 auto;

  &.vue-slider {
    margin: auto;
  }

  & .controllabel, & >>> svg .controllabel {
    font-size: 12px;
    max-width: 600px;
    display: block;
    margin: 0 auto;
    text-align: left;
    padding: 0;
    height: 24px;
    fill: #777;
  }

  & .d3-viz {
    min-height: 80vh;
    margin: 0 auto;
    text-align: center;

    & div {
      margin: 0 auto;
    }
  }
}
</style> 


